app.factory("Season", ["$http", function ($http) {
  var Season = {};

  Season.list = function () {
    return $http.get("/seasons")
      .then(function (resp) {
        return resp.data;
      });
  };

  Season.getById = function (id) {
    return $http.get("/seasons/" + id)
      .then(function (resp) {
        return resp.data;
      });
  };

  Season.getCurrent = function () {
    return $http.get("/seasons/current")
      .then(function (resp) {
        return resp.data;
      });
  };

  Season.add = function (season) {
    var seasonObject = {
      year: season.year,
      season: season.season,
      weeks: season.weeks
    };

    return $http.post("/seasons", seasonObject)
      .then(function (resp) {
        return resp.data;
      });
  };

  Season.delete = function (id) {
    var url = "/seasons/"+ id;

    return $http.delete(url)
      .then(function (resp) {
        return resp.data;
      });
  };

  Season.insertWeek = function (params) {
    var url = "/seasons/" + params.seasonId + "/week/after/" + params.weekNumber;

    var body = {
      startDate: params.startDate,
      endDate: params.endDate
    };

    return $http.post(url, body)
      .then(function (resp) {
        return resp.data;
      });
  };

  Season.editWeek = function (params) {
    var url = "/seasons/" + params.seasonId + "/week/" + params.weekNumber;

    var body = {
      startDate: params.startDate,
      endDate: params.endDate
    };

    return $http.put(url, body)
      .then(function (resp) {
        return resp.data;
      });
  };

  Season.deleteWeek = function (seasonId, weekNumber) {
    var url = "/seasons/" + seasonId + "/week/" + weekNumber + '/delete';

    return $http.post(url)
      .then(function (resp) {
        return resp.data;
      });
  };

  return Season;
}]);
